// @ts-nocheck
//Smooth Scroll
import { Link } from 'react-scroll';

// レイアウト
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

function F_supplies() {

  return (
    <div className="facility-lower">
      <h2 className="tag-title">備品・名刺</h2>
      <Row className="toc-btnArea">
        <Col sm={4} className='toc-btn'>
          <Link
            to="chapter01"
            smooth={true}
            duration={500}
            offset={-100}
            className='btn main-btn type-internal w-100'
          >
            備品の発注について
          </Link>
        </Col>
        <Col sm={4} className='toc-btn'>
          <Link
            to="chapter02"
            smooth={true}
            duration={500}
            offset={-100}
            className='btn main-btn type-internal w-100'
          >
            名刺の発注について
          </Link>
        </Col>
      </Row>
      <section className="sec-supplies">
        <h3 id="chapter01" className='icon-title type-pencil'>備品の発注について</h3>
        <iframe src="https://docs.google.com/presentation/d/15knx0xkeDtHdvfuMZ00vKtSEFMsL0jHkEDkkYBuFSAo/preview?slide=id.p" width="860" height="520" allow="autoplay"></iframe>

        <h3 id="chapter02" className='icon-title type-pencil'>名刺の発注について</h3>
        <iframe src="https://docs.google.com/presentation/d/1Fz8sJbDv3oBx1446IPCkndSpmknf7dPImM9749U-Ozk/preview?slide=id.p" width="860" height="520" allow="autoplay"></iframe>
      </section>
    </div>
  );
}

export default F_supplies;

